import { createSlice } from "@reduxjs/toolkit";
import {
  CampaignInitialStatus,
  GetCampaignData,
  GetSingleCampaignData,
} from "../../../../types/eventManage/campaigns";
import {
  createCampaignAsync,
  getAllCampaignAsync,
  singleCampaignDataAsync,
  updateCampaignAsync,
} from "./CampaignApi";

const initialState: CampaignInitialStatus<
  GetCampaignData,
  GetSingleCampaignData
> = {
  loading: false,
  manageLoading: false,
  CampaignList: [],
  singleCampaignData: null,
  countCampaign: 0,
};

const manageCampaignSlice = createSlice({
  name: "admin-pendingRequest",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // create
    builder
      .addCase(createCampaignAsync.pending, (state) => {
        state.manageLoading = true;
      })
      .addCase(createCampaignAsync.fulfilled, (state) => {
        state.manageLoading = false;
      })
      .addCase(createCampaignAsync.rejected, (state) => {
        state.manageLoading = false;
      });

    // get all
    builder
      .addCase(getAllCampaignAsync.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getAllCampaignAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.CampaignList = action.payload.data;
        state.countCampaign = action.payload.length;
      })
      .addCase(getAllCampaignAsync.rejected, (state) => {
        state.loading = false;
        state.CampaignList = [];
        state.countCampaign = 0;
      });

    // update
    builder
      .addCase(updateCampaignAsync.pending, (state) => {
        state.manageLoading = true;
      })
      .addCase(updateCampaignAsync.fulfilled, (state) => {
        state.manageLoading = false;
      })
      .addCase(updateCampaignAsync.rejected, (state) => {
        state.manageLoading = false;
      });

    // single
    builder
      .addCase(singleCampaignDataAsync.pending, (state) => {
        state.manageLoading = true;
        state.singleCampaignData = null;
      })
      .addCase(singleCampaignDataAsync.fulfilled, (state, action) => {
        state.manageLoading = false;
        state.singleCampaignData = action.payload;
      })
      .addCase(singleCampaignDataAsync.rejected, (state) => {
        state.manageLoading = false;
        state.singleCampaignData = null;
      });
  },
});

export default manageCampaignSlice;
